import { createIntl, createIntlCache } from "react-intl";

import messages from "@i18n/en";

const cache = createIntlCache();
export const intl = createIntl({ locale: "en", messages }, cache);
